var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.197,
    height: 21.236,
    viewBox: "0 0 21.197 21.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17181",
    "data-name": "Groupe 17181",
    transform: "translate(7059 17759.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17171",
    "data-name": "Groupe 17171",
    transform: "translate(-7057.233 -17746.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12060",
    "data-name": "Trac\\xE9 12060",
    d: "M2,14.5h8.17v8.391H3.546A1.553,1.553,0,0,1,2,21.345Z",
    transform: "translate(-2 -14.5)",
    fill: "#ec6321"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17172",
    "data-name": "Groupe 17172",
    transform: "translate(-7047.739 -17746.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12061",
    "data-name": "Trac\\xE9 12061",
    d: "M20.92,14.5v6.845a1.553,1.553,0,0,1-1.546,1.546H12.75V14.5Z",
    transform: "translate(-12.75 -14.5)",
    fill: "#ec6321"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17173",
    "data-name": "Groupe 17173",
    transform: "translate(-7059 -17752.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12062",
    "data-name": "Trac\\xE9 12062",
    d: "M0,8.546v2.208A1.553,1.553,0,0,0,1.546,12.3H9.936V7H1.546A1.553,1.553,0,0,0,0,8.546Z",
    transform: "translate(0 -7)",
    fill: "#ec6321"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17174",
    "data-name": "Groupe 17174",
    transform: "translate(-7047.739 -17752.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12063",
    "data-name": "Trac\\xE9 12063",
    d: "M21.141,7H12.75v5.3h8.391a1.553,1.553,0,0,0,1.546-1.546V8.546A1.553,1.553,0,0,0,21.141,7Z",
    transform: "translate(-12.75 -7)",
    fill: "#ec6321"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17175",
    "data-name": "Groupe 17175",
    transform: "translate(-7049.063 -17759.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12064",
    "data-name": "Trac\\xE9 12064",
    d: "M11.912,7.1a.664.664,0,0,1-.655-.76C11.584,4.132,13.309-.045,17.5-.045c2.394,0,3.242,1.294,3.242,2.4C20.745,4.325,18,7.1,11.912,7.1ZM17.5,1.281c-3.164,0-4.365,3.007-4.763,4.474a10.615,10.615,0,0,0,4.976-1.286c1.257-.746,1.7-1.581,1.7-2.114,0-.793-.99-1.075-1.917-1.075Z",
    transform: "translate(-11.25 0.045)",
    fill: "#ec6321"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17176",
    "data-name": "Groupe 17176",
    transform: "translate(-7057.233 -17759.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12065",
    "data-name": "Trac\\xE9 12065",
    d: "M10.833,7.1C4.742,7.1,2,4.325,2,2.357c0-1.108.85-2.4,3.243-2.4,4.193,0,5.918,4.177,6.244,6.385a.662.662,0,0,1-.655.759ZM5.244,1.281c-.927,0-1.918.283-1.918,1.076,0,1.128,1.972,3.183,6.68,3.4-.4-1.468-1.6-4.475-4.761-4.475Z",
    transform: "translate(-2.001 0.044)",
    fill: "#ec6321"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGift);
export default __webpack_public_path__ + "static/media/ic-gift.c20e9200dc74a9294f8a636295e53d9b.svg";
export { ForwardRef as ReactComponent };